import { filterItemAdmin, filterItemSrs } from "utils/AssetsData";
import { TABLE_TYPE } from "utils/Constants";

export type searchPropType = {
  target: string;
  role: TABLE_TYPE;
  targetOrigin?: string;
};

export type pagePropType = {
  currentPage: number;
  role: TABLE_TYPE;
};

export type sortPropType = {
  sortObj: {
    field: string;
    dir: string | undefined;
  };
  role: TABLE_TYPE;
};

export type filterPropType = {
  type: string;
  filterList: any[];
  role: TABLE_TYPE;
};

export type StudentTableType = {
  key: string;
  refNum: number;
  studentNumber: string;
  givenName1: string;
  givenName2?: string;
  familyName: string;
  address1?: string;
  address2?: string;
  address3?: string;
  address4?: string;
  auPostCode?: string;
  dob: string;
  sex?: string;
  resultCode?: string;
  schoolCode?: string;
  resultsAvailableFlag?: string;
  year10ResultsAvailableFlag?: string;
  year11ResultsAvailableFlag?: string;
  vrsPin?: number;
  srsLodged: string;
  srsQualCount?: string;
  srsScoreCount?: string;
  admissionApplicationStatus: string;
  applicationMode?: string;
  schoolRated: string;
};

type tableContent = {
  loading: boolean;
  currentPage: number;
  origin: any[];
  tableData: any[];
  paginatedTableData: any[];
  filters: any[];
  sorts: unknown;
  search: string;
  tableDataForCSV?: any[]; //only for admin
  searchOrigin?: string; //only for rater
};

export type StudentSliceType = {
  isLoading: boolean;
  isError: boolean;
  data: Array<StudentTableType>;
  [TABLE_TYPE.STUDENTS]: tableContent;
  [TABLE_TYPE.SRS]: tableContent;
  statistics: {
    totalApplicants: number;
    totalAppliedWhitelabel: number;
    ratedApplicants: number;
    unratedApplicants: number;
    partiallyRatedApplicants: number;
  };
};

const tableContentInitial = {
  loading: false,
  currentPage: 1,
  origin: [],
  tableData: [],
  paginatedTableData: [],
  sorts: {},
  search: ""
};

const adminInitial = {
  ...tableContentInitial,
  tableDataForCSV: [],
  filters: filterItemAdmin
};
const srsInitial = { ...tableContentInitial, filters: filterItemSrs, searchOrigin: "" };

export const StudentTableInit: StudentSliceType = {
  isLoading: false,
  isError: false,
  data: [] as StudentSliceType["data"],
  [TABLE_TYPE.STUDENTS]: adminInitial,
  [TABLE_TYPE.SRS]: srsInitial,
  statistics: {
    totalApplicants: 0,
    totalAppliedWhitelabel: 0,
    ratedApplicants: 0,
    unratedApplicants: 0,
    partiallyRatedApplicants: 0
  }
};
